var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-print-invoice-document"}},[_c('payable-invoice-document-query',{attrs:{"id":_vm.$route.params.id},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var isLoading = ref.isLoading;
var data = ref.data;
return [_c('invoice-document',{attrs:{"invoice":data}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }